import { Component, Input } from '@angular/core';
import { BoxLevelEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/box';
import { ContactInformation } from '../../models/booking-details.model';

@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrl: './contact-information.component.scss'
})
export class ContactInformationComponent {
  @Input({ required: true })
  public contactInformation: ContactInformation | undefined = undefined;
  public boxLevelEnum = BoxLevelEnum;
}
